import { Observable } from 'rxjs';

export interface CompanyRestaurantsTableData
{
    id,
    name,
    thisMonthAmount,
    thisMonthPercentage,
    thisMonthOrdersCount,
    menuItemsCount
}

export abstract class CompanyRestaurantsData {
    abstract getCompanyRestaurantsTableData(): Observable<CompanyRestaurantsTableData[]>;
}